import axios from 'axios'
import Version from '@/service/apis/Version'

export default {
  client() {
    return axios.get(`/static/version.json?m=${Math.random()}`)
  },
  server() {
    return Version.info()
  }
}



// WEBPACK FOOTER //
// ./src/service/Version.js